/**
 * Transport-only reads for project-services views that don't route through
 * the projectServices redux slice — e.g. the job-detail billing table and
 * the work form's crew/service pickers, which keep their own local state.
 */
import apiClient from '@sophocles/http-common';
import { checkHttpStatus } from '@sophocles/utils';

import { ACTIVE_CREW_OPTIONS_PARAMS } from './crewOptionsParams';

export const fetchProjectPerformedServices = params =>
  apiClient
    .get('/project/performedservices/', { params })
    .then(checkHttpStatus)
    .then(response => response.data);

export const fetchActiveCrews = () =>
  apiClient.get('/odl-app/crews/', { params: ACTIVE_CREW_OPTIONS_PARAMS }).then(res => res.data);

export const fetchJobServiceOptions = () =>
  apiClient.get('/odl-app/services/', { params: { limit: 100 } }).then(res => res.data);
